import { render, staticRenderFns } from "./CompareHistoryTable.vue?vue&type=template&id=fc13f76a"
import script from "./CompareHistoryTable.vue?vue&type=script&lang=js"
export * from "./CompareHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports